import { useField } from 'formik';
import { GoogleAutocomplete } from '../GoogleAutocomplete';
import { useCallback, useMemo } from 'react';
import { GooglePlaceAddress } from 'types/user';

interface Props {
    name: string;
}

export const FormGoogleAutocomplete = ({ name }: Props) => {
    const [field, meta] = useField(name);

    const inputProps = useMemo(
        () => ({
            error: meta.touched && Boolean(meta.error),
            helperText: meta.touched && meta.error,
        }),
        [meta],
    );

    const changeHandler = useCallback(
        (address: GooglePlaceAddress | null) => {
            field.onChange({ target: { name, value: address } });
        },
        [field, name],
    );

    return <GoogleAutocomplete {...field} InputProps={inputProps} onChange={changeHandler} />;
};
